import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

interface AutoCompleteProps {
    value?: any;
    onChange?: any;
    label?: string;
    options?: any;
    fullWidth?: boolean;
    size?: string;
    loading?: boolean;
    type?: string;
    hiddeArrow?: boolean;
    onMouseDownCapture?: any;
    disabled?: boolean;
    defaultValue?: any;
    handleInputChange?: any;
    readOnly?: boolean;
    required?: boolean;
    onInputChange?: any;
    templateLabel?: any;
    width?: any;
    name: string;
    errors?: any;
    disableClearable?: any;
    warning?: boolean;
    noOptionsText?: string;
    getOptionDisabled?: any;
}
export default function AutocompleteComponent(props: any) {
    const {
        value,
        onChange,
        label,
        options,
        fullWidth = false,
        size = 'medium',
        loading,
        type,
        hiddeArrow = false,
        onMouseDownCapture,
        disabled = false,
        handleInputChange,
        readOnly = false,
        required = false,
        onInputChange,
        templateLabel,
        width = null,
        name,
        errors,
        disableClearable,
        warning,
        noOptionsText,
        getOptionDisabled
    }: AutoCompleteProps = props;

    return (
        <Autocomplete
            clearIcon={<HighlightOffIcon color="primary" />}
            value={value || null}
            disabled={disabled}
            disableClearable={disableClearable}
            options={options || []}
            loading={loading}
            getOptionDisabled={getOptionDisabled}
            isOptionEqualToValue={(option, value) => {
                return option?.id === value?.id || option?.id === value || option?.nombre === value;
            }}
            getOptionLabel={(option: any) => {
                let auxOption: any = option;
                if (typeof option === 'number') {
                    auxOption = options?.find((i: any) => i?.id === option);
                } else if (typeof option === 'string') {
                    auxOption = options?.find((i: any) => i?.nombre === option);
                }
                return templateLabel
                    ? templateLabel(auxOption)
                    : auxOption?.nombre || auxOption?.descripcion;
            }}
            onChange={(_: any, value: any) => {
                if (onChange) onChange(value);
                else return null;
            }}
            loadingText="Cargando..."
            noOptionsText={noOptionsText || 'Sin opciones'}
            onMouseDownCapture={onMouseDownCapture}
            freeSolo={hiddeArrow}
            onInputChange={(_, value) => {
                if (onInputChange && value !== 'undefined') return onInputChange(value);
                if (!handleInputChange) return;
                handleInputChange(value);
            }}
            readOnly={readOnly}
            fullWidth={fullWidth}
            renderOption={(props, option) => {
                return templateLabel ? (
                    <li {...props} key={option.id}>
                        {templateLabel(option)}
                    </li>
                ) : (
                    <li {...props} key={option.id}>
                        {option.nombre || option?.descripcion}
                    </li>
                );
            }}
            sx={{ width: { width } }}
            renderInput={(params: any) => (
                <TextField
                    {...params}
                    id={params.id}
                    label={label}
                    size={size}
                    name={name}
                    sx={
                        (warning && {
                            '& fieldset': {
                                borderColor: '#FABC00 !important',
                                borderWidth: '2px !important'
                            },
                            '& label': {
                                color: '#FABC00 !important'
                            }
                        }) ||
                        {}
                    }
                    helperText={errors && name && errors[name]}
                    error={!!errors && name && !!errors[name]}
                    required={required}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}

                                {type === 'search' ? (
                                    <>
                                        {params.InputProps.endAdornment}
                                        {!params.inputProps.value && (
                                            <SearchIcon color="primary" fontSize="medium" />
                                        )}
                                    </>
                                ) : (
                                    params.InputProps.endAdornment
                                )}
                            </>
                        )
                    }}
                />
            )}
        />
    );
}
